import type { Platform } from 'src/types/platform';

const KEY = 'platforms_cache';

type Cache = { data: Platform[]; updatedAt: number };

const read = (): Cache | null => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Cache) : null;
  } catch {
    return null;
  }
};

export const getCachedPlatforms = (): Platform[] | undefined | null => read()?.data;

export const getCachedPlatformsUpdatedAt = (): number | undefined => read()?.updatedAt;

export const setCachedPlatforms = (data: Platform[]): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ data, updatedAt: Date.now() }));
  } catch {
    // do nothing
  }
};

export const clearPlatformCache = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // do nothing
  }
};
